export default __webpack_public_path__ + "static/media/Wavebreaker.e2c740d7.jpg";